(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('carte', {
            parent: 'entity',
            url: '/carte?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.carte.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/carte/cartes.html',
                    controller: 'CarteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carte');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('carte-detail', {
            parent: 'carte',
            url: '/carte/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.carte.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/carte/carte-detail.html',
                    controller: 'CarteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carte');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Carte', function($stateParams, Carte) {
                    return Carte.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'carte',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('carte-detail.edit', {
            parent: 'carte-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/carte/carte-dialog.html',
                    controller: 'CarteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Carte', function(Carte) {
                            return Carte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('carte.new', {
            parent: 'carte',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/carte/carte-dialog.html',
                    controller: 'CarteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                prenom: null,
                                taille: null,
                                sexe: null,
                                metier: null,
                                lieuNaissance: null,
                                dateCreate: null,
                                dateExpr: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('carte', null, { reload: 'carte' });
                }, function() {
                    $state.go('carte');
                });
            }]
        })
        .state('carte.edit', {
            parent: 'carte',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/carte/carte-dialog.html',
                    controller: 'CarteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Carte', function(Carte) {
                            return Carte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('carte', null, { reload: 'carte' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('carte.delete', {
            parent: 'carte',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/carte/carte-delete-dialog.html',
                    controller: 'CarteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Carte', function(Carte) {
                            return Carte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('carte', null, { reload: 'carte' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
